import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import IconButton from "../Buttons/IconButton";
import SVG from "../SVG/icons";
import { HintTooltip } from "./styled";
import PropTypes from "prop-types";
import WrapperContainer from "../Containers/WrapperContainer";
import FlexContainers from "../Containers/FlexContainers";

const TooltipIcon = ({ children, tooltipWidth = "240px" }) => {
  const iconRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const handleMouseMove = () => setActive(true);
    const handleMouseLeave = () => setActive(false);

    if (iconRef && iconRef.current) {
      iconRef.current.addEventListener("mousemove", handleMouseMove);
      iconRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (iconRef && iconRef.current) {
        iconRef.current.removeEventListener("mousemove", handleMouseMove);
        iconRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [iconRef, iconRef.current]);

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} innerRef={iconRef}>
      <IconButton tooltipComponent={<HintTooltip width={tooltipWidth}>{children}</HintTooltip>}>
        {active ? <SVG.QuestionMarkIcon /> : <SVG.QuestionMarkOutlineIcon />}
      </IconButton>
    </WrapperContainer>
  );
};

TooltipIcon.propTypes = {
  children: PropTypes.string,
  tooltipWidth: PropTypes.string
};

export default TooltipIcon;
